import React from 'react';
import * as S from './style';
import { CategoryTab } from 'components';
import FeatureWrapper, { Props as FeatureWrapperProps } from 'components/molecules/FeatureWrapper';

export interface Props {
    searchTypes: Array<{ name: string; isActive: boolean; onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void }>;
    serviceFeature: { totalCount: number; list: Array<FeatureWrapperProps> };
}

function FeatureInfo({ ...props }: Props): React.ReactElement {
    const { totalCount, list } = props.serviceFeature;

    return (
        <S.FeatureInfoContainer>
            <S.TabWrapper>
                <CategoryTab categorys={props.searchTypes} />
            </S.TabWrapper>
            {totalCount > 0 ? (list.map((item, index) => (
                <FeatureWrapper key={index} {...item} />
            ))) : 
            <S.NoServiceOffer>
                등록된 제공 서비스가 없습니다.
            </S.NoServiceOffer>}
        </S.FeatureInfoContainer>
    );
}

export default FeatureInfo;
